import React, { useCallback, useEffect, useState } from "react";
import { corporateDataCapture as v } from "./validate";
import { Field, getFormValues } from "redux-form";
import { connect, useSelector } from "react-redux";
import { isAgent, isCorporate, isSuperAgent, token } from "../../modules/auth";
import { Select } from "../../ui";
import {
  corporateAccountBookingDesksUnload,
  corporateDepartmentsUnload,
  fetchCompanyBranches,
  fetchCorporateAccountUsers,
  fetchCorporateBookingDesks,
  fetchCorporateDepartments,
  unloadCompanyBranches,
  unloadCorporateAccountUsers,
} from "../../redux/actions";
import { canCreateHighlyConfidentialRfp, corporateAccountObject } from "../../modules/permissions";
import { Toggle } from "../../Components/Form";
import { LiveSearchSimple } from "../../Components/Form/LiveSearch/LiveSearchSimple";

const mapStateToProps = state => {
  return {
    token: token(state),
    isCorporate: isCorporate(state),
    isSuperAgent: isSuperAgent(state),
    isAgent: isAgent(state),
    corporateAccount: corporateAccountObject(state.auth),
    canCreateHighlyConfidentialRfp: canCreateHighlyConfidentialRfp(state.auth),
    ...state.corporateBookingDesks,
    ...state.corporateAccountUsers,
    ...state.corporateDepartments,
    ...state.companyBranches,
  };
};

const mapDispatchToProps = {
  fetchCorporateBookingDesks,
  corporateAccountBookingDesksUnload,
  fetchCorporateDepartments,
  corporateDepartmentsUnload,
  fetchCorporateAccountUsers,
  unloadCorporateAccountUsers,
  fetchCompanyBranches,
  unloadCompanyBranches,
};

const CorporateSpecificEnquiryData = ({
                                        change,
                                        form,
                                        company,
                                        corporateAccount,
                                        canCreateHighlyConfidentialRfp,
                                        token,
                                        isAgent,
                                        isSuperAgent,
                                        fetchCompanyBranches,
                                        companyBranches,
                                        corporateAccountBookingDesksUnload,
                                        unloadCorporateAccountUsers,
                                        corporateDepartmentsUnload,
                                        fetchCorporateBookingDesks,
                                        fetchCorporateDepartments,
                                        fetchCorporateAccountUsers,
                                        unloadCompanyBranches,
                                        meetingHostId,
                                        corporateAccountUsers,
                                        corporateBookingDesks,
                                        corporateDepartments,
                                      }) => {
  const [bookingDesk, setBookingDesk] = useState(null);
  const [department, setDepartment] = useState(null);
  const [meetingHost, setMeetingHost] = useState(null);
  const values = useSelector(getFormValues(form));

  useEffect(() => {
    if (corporateAccount && corporateAccount.id) {
      fetchCorporateBookingDesks(corporateAccount.id, token);
      fetchCorporateDepartments(corporateAccount.id, token);
      fetchCorporateAccountUsers(corporateAccount.id, token);
    }
    return () => {
      corporateAccountBookingDesksUnload();
      corporateDepartmentsUnload();
      unloadCorporateAccountUsers();
    };
  }, []);

  useEffect(() => {
    if (!isAgent && company) {
      fetchCompanyBranches(company?.id, token);
    }
    if (company?.corporate_account_id) {
      fetchCorporateBookingDesks(
        company.corporate_account_id,
        token,
      );
      fetchCorporateDepartments(
        company.corporate_account_id,
        token,
      );
      fetchCorporateAccountUsers(
        company.corporate_account_id,
        token,
      );
    }
    return () => {
      unloadCompanyBranches();
      corporateAccountBookingDesksUnload();
      corporateDepartmentsUnload();
      unloadCorporateAccountUsers();
    };
  }, [company]);

  useEffect(() => {
    handleMeetingHostSelection(meetingHostId);
  }, [meetingHostId]);

  useEffect(() => {
    handleMeetingHostSelection(meetingHostId);
  }, [corporateAccountUsers]);

  useEffect(() => {
    if (
      values.meeting_host_id &&
      corporateAccountUsers &&
      corporateAccountUsers.users
    ) {
      corporateAccountUsers.users.map(user => {
        if (
          meetingHost &&
          meetingHost.id === user.id &&
          user.department != null
        ) {
          if (
            typeof values.department_id === "undefined" ||
            values.department_id === null
          ) {
            change(form, "department_id", user.department);
          }
          setDepartment(user.department);
        }
      });
      // let meetingHost = props.corporateAccountUsers.users.filter((user) => {
      //   return user.user_id == values.meeting_host_id;
      // })[0];
    }
    if (meetingHost) {
      change(form, "meeting_host_id", meetingHost.id);
    }
  }, [meetingHost]);

  const getBookingDesksOptions = () => {
    let options = [];
    if (
      company.default_booking_desk_id &&
      company.default_booking_desk
    ) {
      options.push({
        text: company.default_booking_desk.name,
        value: company.default_booking_desk.id,
      });
    }
    if (corporateBookingDesks && corporateBookingDesks.length > 0) {
      corporateBookingDesks.map(corporateBookingDesk => {
        options.push({
          text: corporateBookingDesk.name,
          value: corporateBookingDesk.id,
        });
      });
    }
    options.sort((a, b) => a.text.localeCompare(b.text));
    return options;
  };

  const getDepartmentsOptions = () => {
    let options = [];
    if (corporateDepartments && corporateDepartments.length > 0) {
      const departmentMap = new Map();
      corporateDepartments.forEach(department => {
        const { id, name, parent } = department;
        departmentMap.set(id, {
          text: name,
          value: id,
          parentId: parent ? parent.id : null,
        });
      });

      corporateDepartments.forEach(department => {
        const { id, name, parent } = department;
        if (parent) {
          options.push({ text: name, value: id });
        }
      });

      corporateDepartments.forEach(department => {
        const { id, name, parent } = department;
        if (!parent) {
          options.push({ text: name, value: id });
        }
      });
    }

    return options;
  };

  const getMeetingHostsOptions = () => {
    let options = [];
    if (
      corporateAccountUsers &&
      corporateAccountUsers.users &&
      corporateAccountUsers.users.length > 0
    ) {
      corporateAccountUsers.users.map(user => {
        options.push({
          text: user.first_name + " " + user.surname + " (" + user.email + ")",
          value: user.id,
        });
      });
    }
    return options;
  };

  const getCompanyBranchesOptions = useCallback(() => {
    let options = [];
    if (companyBranches && companyBranches.length > 0) {
      companyBranches.map(branch => {
        if (branch.deleted_at === null) {
          options.push({
            text: branch.name,
            value: branch.id,
          });
        }
      });
    }
    return options;
  }, [companyBranches]);

  const handleMeetingHostSelection = meetingHostId => {
    if (corporateAccountUsers && corporateAccountUsers.users) {
      corporateAccountUsers.users.map(user => {
        if (meetingHostId === user.id) {
          setMeetingHost(user);
        }
      });
    }
  };

  return (
    <>
      <div className="row mb-4">
        <div className="col col-w-1/4">
          <LiveSearchSimple
            auth
            label="Meeting Host"
            getText={result =>
              result.first_name + " " + result.surname + ": " + result.email
            }
            url={`${window.API}/users?corporateUser=1&corporateId=${company?.corporate_account_id}`}
            onChange={setMeetingHost}
            query="companyUser"
            onClear={() => setMeetingHost(null)}
            placeholder={
              meetingHost &&
              meetingHost.first_name +
              " " +
              meetingHost.surname +
              ": " +
              meetingHost.email
            }
            validate={
              getMeetingHostsOptions().length > 0 ? v.meeting_host_id : null
            }
            wrapperClassName="inline mb-8 xl:w-1/2"
          />
          {/*<Field*/}
          {/*  name="meeting_host_id"*/}
          {/*  label="Meeting Host"*/}
          {/*  component={Select}*/}
          {/*  options={getMeetingHostsOptions()}*/}
          {/*  validate={getMeetingHostsOptions().length > 0 ? v.meeting_host_id : null}*/}
          {/*  onChange={e => {*/}
          {/*    handleMeetingHostSelection(e.target.value);*/}
          {/*    if (values.meeting_host_id && props.corporateAccountUsers && props.corporateAccountUsers.users) {*/}
          {/*      let meetingHost = props.corporateAccountUsers.users.filter((user) => {*/}
          {/*        return user.user_id == values.meeting_host_id;*/}
          {/*      })[0];*/}
          {/*      props.change(props.form, "department_id", meetingHost.department);*/}
          {/*    }*/}
          {/*  }}*/}
          {/*  wrapperClassName="inline mb-8 xl:w-1/2"*/}
          {/*/>*/}
        </div>
        <div className="col col-w-1/4">
          {getDepartmentsOptions().length > 0 && (
            <Field
              name="department_id"
              label="Department"
              validate={v.department_id}
              component={Select}
              options={getDepartmentsOptions()}
              onChange={e => setDepartment(e.target.value)}
              wrapperClassName="inline mb-8 xl:w-1/2"
            />
          )}
        </div>
        {corporateAccount &&
        corporateAccount.is_pharmaceutical &&
        corporateAccount.show_internal_external_on_brief ? (
          <Field name="is_external" label="Is external?" component={Toggle} />
        ) : null}
      </div>
      {getCompanyBranchesOptions().length > 0 ? (
        <div className="row">
          <div className="col md:w-1/4">
            <Field
              name="branch_id"
              label="Branch"
              component={Select}
              options={getCompanyBranchesOptions()}
              wrapperClassName="inline mb-8 xl:w-1/2"
              validate={v.branch_id}
            />
          </div>
        </div>
      ) : null}

      {canCreateHighlyConfidentialRfp ? (
        <div className="row">
          <div className="col col-w-1/4">
            <Field
              name="is_highly_confidential"
              label="Is Confidential?"
              component={Toggle}
            />
          </div>
        </div>
      ) : null}

      <div className="row mb-4">
        <div className="col col-w-1/4">
          {isSuperAgent && getBookingDesksOptions().length > 0 ? (
            <Field
              name="booking_desk_id"
              label="Booking Desk"
              component={Select}
              options={getBookingDesksOptions()}
              onChange={e => {
                if (e.target.value == "") {
                  change(form, "agency_booking_desk_id", null);
                } else if (
                  e.target.value == company.default_booking_desk_id
                ) {
                  change(
                    form,
                    "agency_booking_desk_id",
                    e.target.value,
                  );
                } else if (
                  e.target.value != company.default_booking_desk_id
                ) {
                  change(form, "agency_booking_desk_id", null);
                }
                setBookingDesk(e.target.value);
              }}
              // validate={v.booking_desk_id}
              wrapperClassName="inline mb-8 xl:w-1/2"
            />
          ) : null}
        </div>
      </div>
    </>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CorporateSpecificEnquiryData);
